import { Component, DestroyRef, inject, Input, OnInit, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { GroupOfPoliciesComponent } from '@components/managements/group-of-policies/group-of-policies.component';
import { PoliciesComponent } from '@components/managements/policies/policies.component';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { BanksComponent } from '@components/managements/banks/banks.component';
import { PolicyService } from '@services/policy.service';
import { FormArray, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { Observable } from 'rxjs';
import { CollectionService } from '@services/collection.service';

@Component({
  selector: 'app-collection',
  standalone: true,
  imports: [ReactiveFormsModule, NgSelectModule],
  providers: [PolicyService, CollectionService],
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionComponent implements OnInit {

  @Input() policy: any
  @Input() year: any
  @Input() saveData: boolean
  @Output() sendData = new EventEmitter<any>()

  private _policyService = inject(PolicyService)
  private _collectionService = inject(CollectionService)
  private fb = inject(FormBuilder)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  protected collectionsForm = this.fb.group({
    collections: this.fb.array([])
  });
  private numberPattern = Validators.pattern('^[0-9]+(\\.[0-9]+)?$');

  public lifeCoverageForm = this.fb.group({
    _id: [null],  
    coverageId: [null, [Validators.required]],
    coverageYear: [null, [Validators.required, this.numberPattern]],
    life: [null, [Validators.required, this.numberPattern]],
    taxesLife: [false, [Validators.required]],
    ma: [null, [Validators.required, this.numberPattern]],
    taxesMa: [false, [Validators.required]],
    invacc: [null, [Validators.required, this.numberPattern]],
    taxesInvacc: [false, [Validators.required]],
    inv23: [null, [Validators.required, this.numberPattern]],
    taxesInv23: [false, [Validators.required]],
    limitLife: [0],
    limitMa: [0],
    limitInv23: [0],
    limitInvacc: [0],
    limitHealth: [0],
    limitCatas: [0],
    limitDental: [0],
    limitChildren: [0]
  })

  ngOnInit(): void {
    if (this.policy._id) {
      this.getCollection()
    }
  }

  get collectionsArray() {
    return this.collectionsForm.get('collections') as FormArray;
  }

  createCollectionGroup(collection?: any) {
    
      return this.fb.group({
        _id: [collection._id],
        coverageId: [collection.coverageId, [Validators.required]],
        coverageYear: [collection.coverageYear, [Validators.required, this.numberPattern]],
        dependent: [collection.dependent, [Validators.required, this.numberPattern]],
        health: [collection.health, [this.numberPattern]],
        taxesHealth: [collection.taxesHealth],
        catas: [collection.catas, [this.numberPattern]],
        taxesCatas: [collection.taxesCatas],
        dental: [collection.dental, [this.numberPattern]],
        taxesDental: [collection.taxesDental],
      });
    
  }

  loadCollections(res: any[]) {
    this.collectionsArray.clear();
    res.forEach(c => {
      this.collectionsArray.push(this.createCollectionGroup(c));
    });
  }

  getCollection() {
    this._policyService.getCollection(this.policy.coverageId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res) {
        this.lifeCoverageForm.patchValue(res[0])
        this.loadCollections(res)
      }
    })
  }

  createSection() {
    this._collectionService.createCollection(this.policy.coverageId, this.policy.year).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.getCollection()
    })
  }

  updateCollection(collection: any) {
    this._collectionService.updateCollection(collection).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
    })
  }

  deleteStage(collection: any){
    this._collectionService.deleteCollection(collection).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.getCollection()
    })
  }

  verifyNumberKey(event: KeyboardEvent): void {
    const char = String.fromCharCode(event.keyCode);
    // Permitir solo números y un solo punto
    if (!/[0-9.]/.test(char) || (char === '.' && (event.target as HTMLInputElement).value.includes('.'))) {
      event.preventDefault();
    }
  }

}
